module.exports = __webpack_public_path__ + "fonts/ClearSans-Thin-webfont784d1b2b5701c6ea87520a140c18af95.woff";